<template>
  <div class="home">
    <div class="mainBox">
      <h2>{{message}}</h2>
      <div v-for="(value, index) in list" :key="index">
        <h3>Cap Payload: {{value.cap_payload}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Payload from '@/api/payload'
import User from '@/api/user'

export default {
  name: 'home',
  data () {
    return {
      list: [],
      message: ''
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      const userData = await User.login({
        token: process.env.VUE_APP_TOKEN
      })
      try {
        const response = await Payload.getAll(userData.jwt, this.$route.params.pb_key)
        if (response !== undefined) {
          if (response.data.length > 0) {
            this.message = 'Success!'
          } else {
            this.message = 'Empty!'
          }
        } else if (response === undefined) {
          this.message = 'Error!'
        }
        this.list = response.data
      } catch (e) {
        this.message = 'Empty!'
      }
    },
    log (val) {
      console.log(val)
    }
  }
}
</script>
<style lang="scss">
  .mainBox {
    display: flex;
    flex-direction: column;
    background-color: #fff8f8;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 40px;
      button {
        border-radius: 40px;
        padding: 10px 20px 10px 20px;
        span {
          font-size: 14px;
          font-weight: bold;
          line-height: 1.6;
          text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        }
        @media screen and (max-width: 375px) {
          padding: 5px 10px 5px 10px;
          span {
            font-size: 13px;
          }
        }
        @media screen and (max-width: 320px) {
          padding: 4px 8px 4px 8px;
          span {
            font-size: 10px;
          }
        }
      }
    }
  }
</style>
